var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_vm._l((_vm.data),function(item,i){return [(item.meta && item.meta.breadcrumbLinkDisable)?_c('el-breadcrumb-item',{key:i},[_vm._v(_vm._s(item.name))]):_c('el-breadcrumb-item',{key:i,attrs:{"to":{path: item.path}}},[_vm._v(_vm._s(item.name))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }